import MuiAlert, { AlertProps } from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import Stack from "@mui/material/Stack";
import * as React from "react";

import { ICustomizedSnackbars } from "./models";

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function CustomizedSnackbars(
  props: ICustomizedSnackbars
): JSX.Element {
  const [open, setOpen] = React.useState(props.open);

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <Stack spacing={2} sx={{ width: "100%", marginTop: "5rem" }}>
      <Snackbar
        style={{ marginTop: "3rem" }}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={props?.anchorOrigin}>
        <Alert
          onClose={handleClose}
          severity={props.type}
          sx={{ width: "100%", display: "flex", gap: "8px" }}>
          {props.title}
        </Alert>
      </Snackbar>
    </Stack>
  );
}
